import axios from 'axios'

export const getAllAdmins = (params) => {
  return axios.get('/clients', {params: params})
}



// WEBPACK FOOTER //
// ./src/api/admins.js